
//Libraries
import { defineComponent, onMounted, ref } from "vue";

//Composables
import useRandom from "../../shared/composables/useRandom";

export default defineComponent({
  name: "RightBarContentShopModule",
  setup() {
    //Data

    const isLoading = ref<boolean>(true);

    const gamesCount = ref<number>(0);

    //Use
    const { randomNumber, runRandom, stopRandom } = useRandom();

    //Methods

    const getAppData = async (): Promise<any> => {
      return true;
    };

    //Lifecycle Hooks

    onMounted(() => {
      runRandom();
      getAppData().then(() => {
        setTimeout(() => {
          stopRandom();
          gamesCount.value = 200; //data;
          isLoading.value = false;
        }, 1000);
      });
    });

    return {
      //Data
      isLoading,
      randomNumber,
      gamesCount,
    };
  },
});
